
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/awards-and-recognition",
      function () {
        return require("private-next-pages/awards-and-recognition.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/awards-and-recognition"])
      });
    }
  